var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"con_mpw"},[_c('v-row',{staticClass:"scrollH100",attrs:{"no-gutters":""}},[(_vm.getOrgname())?_c('v-col',{attrs:{"col":"12"}},[_c('company',{ref:"company"})],1):_c('v-col',{attrs:{"col":"12","id":"feepay"}},[_c('user',{ref:"user"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }